// extracted by mini-css-extract-plugin
export default {"containerError404":"Error404_containerError404__WG03Q","errorPage":"Error404_errorPage__D+IlI","btnSize":"Error404_btnSize__YyfyQ"};